import { Component, Input, EventEmitter, Output, OnChanges } from '@angular/core';
import { DealStatus } from 'app/models/dto/deal-status.model';
import * as _ from 'lodash';
import { MatDialog } from '@angular/material/dialog';
import { DealStatusReasonDialogComponent } from '../deal-status-reason-dialog/deal-status-reason-dialog.component';
import { take } from 'rxjs/operators';
import { dealStageColorClassMap } from 'ng2-app/util/deal/deal.utility';

interface OptionGroup {
  label: string;
  options: DealStatus[];
}

interface StatusUpdate {
  status: string;
  stage: string;
  reason?: string[];
  subReasons?: string[];
  otherReason?: string;
}

@Component({
  selector: 'app-deal-status-picker',
  templateUrl: './deal-status-picker.component.html',
  styleUrls: ['./deal-status-picker.component.scss']
})
export class DealStatusPickerComponent implements OnChanges {


  @Input() status: string;
  @Input() options: DealStatus[];
  @Output() change = new EventEmitter<StatusUpdate>();
  dealStageColorClassMap = dealStageColorClassMap;

  previousOption: DealStatus;
  selectedOption: DealStatus;
  optionGroups: OptionGroup[];

  constructor(
    public dialog: MatDialog
  ) { }

  ngOnChanges() {
    this.previousOption = this.options.find(x => x.value === this.status) as DealStatus;
    this.selectedOption = this.previousOption;
    this.optionGroups = _(this.options)
      .groupBy('stage')
      .map((options, stage) => ({
        stage: stage,
        label: _.startCase(stage),
        options
      }))
      .value();
  }

  handleChange(statusOption: DealStatus): void {
    if (this.previousOption.value === statusOption.value) {
      return;
    }
    if (statusOption.reasonOptions.length) {
      this.openReasonDialog(statusOption);
    } else {
      this.change.emit({
        status: statusOption.value,
        stage: statusOption.stage
      });
    }
  }

  openReasonDialog(statusOption: DealStatus) {
    const dialogRef = this.dialog.open(DealStatusReasonDialogComponent, {
      data: { previousOption: this.previousOption, selectedOption: statusOption }
    });
    dialogRef.afterClosed().pipe(take(1)).subscribe(result => {
      if (!result) {
        this.selectedOption = this.previousOption;
        this.change.emit({
          status: this.previousOption.value,
          stage: this.previousOption.stage
        });
        return;
      }
      this.change.emit({
        status: statusOption.value,
        stage: statusOption.stage,
        reason: result.reason,
        subReasons: result.subReasons,
        otherReason: result.otherReason || null
      });
    });
  }
}
